import styles from './Welcome.module.css';

interface WelcomeProps {
  hasInProgress: boolean;
  includeAdvanced: boolean;
  onBegin: () => void;
  onResume?: () => void;
  onToggleAdvanced: (next: boolean) => void;
}

export function Welcome({
  hasInProgress,
  includeAdvanced,
  onBegin,
  onResume,
  onToggleAdvanced,
}: WelcomeProps) {
  return (
    <section className={styles.welcome}>
      <h1 className={styles.heading}>the card sort</h1>
      <p className={styles.subtitle}>a tarot of yes, no, and curious</p>
      <p className={styles.body}>
        you'll see one card at a time. drag (or tap to choose) into one of five
        columns: hard limit, soft limit, curious, yes, hell yes. there is no
        right answer; you can leave columns empty, change your mind, and revise
        whenever you want. it's only for you.
      </p>

      <label className={styles.toggle}>
        <input
          type="checkbox"
          checked={includeAdvanced}
          onChange={(e) => onToggleAdvanced(e.target.checked)}
        />
        <span>extend the deck (include edge play and advanced cards)</span>
      </label>

      <div className={styles.actions}>
        {hasInProgress && onResume && (
          <button type="button" className={styles.resume} onClick={onResume}>
            resume my sort
          </button>
        )}
        <button type="button" className={styles.begin} onClick={onBegin}>
          {hasInProgress ? 'start over' : 'begin sorting'}
        </button>
      </div>
    </section>
  );
}
